import React from 'react';
import { AlertCircle, Loader2, WifiOff } from 'lucide-react';

/**
 * Shared offline / config loading / error UI for Stripe checkout flows.
 */
const StripeCheckoutStatus = ({
  isOnline,
  isChecking,
  loading,
  error,
  onRetry,
  loadingMessage = 'Loading payment settings...',
}) => {
  if (!isOnline) {
    return (
      <div className="border-2 border-yellow-200 rounded-lg p-6 bg-yellow-50">
        <div className="flex items-center text-yellow-800 mb-2">
          <WifiOff className="w-5 h-5 mr-2" />
          <span className="font-semibold">No internet connection</span>
        </div>
        <p className="text-sm text-yellow-900 mb-3">
          Reconnect to load payment settings and complete checkout
          {isChecking ? '...' : '.'}
        </p>
        {onRetry && (
          <button
            type="button"
            onClick={onRetry}
            className="text-sm font-medium text-yellow-900 underline hover:no-underline"
          >
            Try again
          </button>
        )}
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="w-6 h-6 animate-spin text-gray-400 mr-2" />
        <span className="text-gray-600">{loadingMessage}</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-start space-x-2">
          <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm text-red-600">{error}</p>
            {onRetry && (
              <button
                type="button"
                onClick={onRetry}
                className="mt-3 text-sm font-medium text-red-700 underline hover:no-underline"
              >
                Retry
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default StripeCheckoutStatus;
